import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { BadgeCheck, ShieldCheck, DollarSign, Headphones } from "lucide-react";

const FeaturesStrip = () => {
  const { t } = useLanguage();

  const items = [
    { icon: BadgeCheck, title: "feat1", desc: "feat1d" },
    { icon: ShieldCheck, title: "feat2", desc: "feat2d" },
    { icon: DollarSign, title: "feat3", desc: "feat3d" },
    { icon: Headphones, title: "feat4", desc: "feat4d" },
  ];

  return (
    <section className="max-w-7xl mx-auto px-6 pt-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {items.map(({ icon: Icon, title, desc }) => (
          <div
            key={title}
            className="flex items-start gap-4 p-5 rounded-2xl border border-teal-100 bg-white hover:rc-shadow transition-all duration-300"
          >
            <span className="w-12 h-12 shrink-0 rounded-xl bg-teal-50 text-teal-600 flex items-center justify-center">
              <Icon className="w-6 h-6" />
            </span>
            <div>
              <h3 className="font-display font-bold text-[#0d3b43]">{t(title)}</h3>
              <p className="text-sm text-slate-500 mt-0.5 leading-snug">{t(desc)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesStrip;
